export const FAMILY_ACTIONS = {
  UPDATE_PIN: "UPDATE_PIN",
  ENABLE_FAMILY: "ENABLE_FAMILY",
  DISABLE_FAMILY: "DISABLE_FAMILY",
  SELECT_MODE: "SELECT_MODE",
};
